var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic-simple-select" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "dropdown",
            rawName: "v-dropdown",
            value: { isBlocked: true, onDropdownClose: _vm.onDropdownClose },
            expression: "{ isBlocked: true, onDropdownClose: onDropdownClose }",
          },
        ],
        staticClass: "form-group with-icon-right dropdown select-form-group",
        class: { "has-error": _vm.hasErrors() },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "input-group dropdown-toggle vuestic-simple-select__dropdown-toggle",
          },
          [
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.displayValue,
                    expression: "displayValue",
                  },
                ],
                class: { "has-value": !!_vm.value },
                attrs: { name: _vm.name, options: _vm.options },
                domProps: { value: _vm.displayValue },
                on: {
                  focus: function ($event) {
                    return _vm.showDropdown()
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.displayValue = $event.target.value
                  },
                },
              }),
              _c("label", { staticClass: "control-label" }, [
                _vm._v(_vm._s(_vm.label)),
              ]),
              _c("i", { staticClass: "bar" }),
              _c(
                "small",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasErrors(),
                      expression: "hasErrors()",
                    },
                  ],
                  staticClass: "help text-danger",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.showRequiredError()) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _c("i", {
              staticClass:
                "ion ion-ios-arrow-down icon-right input-icon vuestic-simple-select__dropdown-arrow",
              on: { click: _vm.showDropdown },
            }),
          ]
        ),
        _vm.isClearable
          ? _c("div", [
              _c("i", {
                staticClass:
                  "fa fa-close icon-cross icon-right input-icon vuestic-simple-select__unselect",
                on: { click: _vm.unselectOption },
              }),
            ])
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "dropdown-menu vuestic-simple-select__dropdown-menu",
            attrs: { "aria-labelledby": "dropdownMenuButton" },
          },
          [
            _c("scrollbar", { ref: "scrollbar" }, [
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu-content vuestic-simple-select__dropdown-menu-content",
                },
                _vm._l(_vm.filteredList, function (option, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "dropdown-item vuestic-simple-select__dropdown-item",
                      class: { selected: _vm.isOptionSelected(option) },
                      on: {
                        click: function ($event) {
                          return _vm.toggleSelection(option)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "ellipsis" }, [
                        _vm._v(
                          _vm._s(_vm.optionKey ? option[_vm.optionKey] : option)
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }